const hasFeature = (featureName: string, userFeatures: string[]) => {
  if (!userFeatures) {
    throw new Error(
      "The userFeatures param is required to check for features while using the User API V3",
    );
  }

  return userFeatures.includes(featureName);
};

export default hasFeature;
